module.exports = __webpack_public_path__ + "media/images/recrutare/home/candidats_pour_reprise_de_cabinet_medical-90c7c9b142d9f6e732a218d8ae73c204.png";